/**
 * Tracks a one-shot request to suppress BizChat's initial prompt auto-focus for the next
 * main-window drawer render. This is used when Outlook restores Copilot Chat from the
 * sticky/pinned-pane setting on boot, because that restore is not an explicit user action
 * and should not steal focus from wherever the user is already navigating.
 *
 * Not part of Satchel store as it doesn't affect rendering and is just metadata.
 * Currently only used in StickyOpen scenario, however other places that need this behavior
 * can call markDisableAutoFocusForCurrentOpen() to mark the flag for the next render. The
 * flag is cleared once BizChat consumes it, or when the drawer closes before consumption.
 */
let shouldDisableAutoFocus = false;

export function markDisableAutoFocusForCurrentOpen(): void {
    shouldDisableAutoFocus = true;
}

export function clearDisableAutoFocusForCurrentOpen(): void {
    shouldDisableAutoFocus = false;
}

export function shouldDisableAutoFocusForCurrentOpen(): boolean {
    return shouldDisableAutoFocus;
}
